export const AiFeaturesAndCredits = {
  title: 'AI features and credits',
  subTitle: 'Manage your credits for AI features'
}
